import { EGarageKind } from '../../../../json_query';
import { ensureSingleTagExists } from '../helpers';
import { ITagDefinition, TTag } from '../index';

const IGarageKindsTagType = 'advanced-garageKind';

export interface IGarageKindsTag {
  type: 'advanced-garageKind';
  value: EGarageKind;
}

export const isGarageKindsTag = (tag: TTag): tag is IGarageKindsTag => tag.type === IGarageKindsTagType;

export const garageKindsTagDefinition: ITagDefinition = {
  reduce: (tags, jsonQuery) => {
    const values = jsonQuery.garage_garage_type && jsonQuery.garage_garage_type.value;

    let nextTags = tags.filter(
      tag => tag.type !== IGarageKindsTagType || (values && values.some(value => value === tag.value)),
    );

    if (values !== undefined) {
      nextTags = values.reduce(
        (result, value: EGarageKind) =>
          ensureSingleTagExists(
            result,
            (tag: TTag): tag is IGarageKindsTag => isGarageKindsTag(tag) && tag.value === value,
            () => ({ type: IGarageKindsTagType, value }),
          ),
        nextTags,
      );
    }

    return nextTags;
  },
};
